// Named colours for data-driven fills (jersey colours, chart series); brand and status colours live in theme.tsx.
// `name` is what a jersey stores, so it must not change.
export const PaletteColor = Object.freeze({
  RED: { name: 'red', hex: '#f44336' },
  PINK: { name: 'pink', hex: '#e91e63' },
  PURPLE: { name: 'purple', hex: '#9c27b0' },
  BLUE: { name: 'blue', hex: '#2196f3' },
  CYAN: { name: 'cyan', hex: '#00bcd4' },
  GREEN: { name: 'green', hex: '#4caf50' },
  YELLOW: { name: 'yellow', hex: '#ffeb3b' },
  AMBER: { name: 'amber', hex: '#ffc107' },
  ORANGE: { name: 'orange', hex: '#ff9800' },
  BROWN: { name: 'brown', hex: '#795548' },
  GREY: { name: 'grey', hex: '#9e9e9e' },
  SILVER: { name: 'silver', hex: '#aaaaaa' },
  LIGHT_GREY: { name: 'lightgrey', hex: '#e6e6e6' },
  BLACK: { name: 'black', hex: '#000000' },
  WHITE: { name: 'white', hex: '#ffffff' },
});

export type PaletteColor = typeof PaletteColor[keyof typeof PaletteColor];
